import React, { useEffect, useState } from "react";
import LoginForm from "../../Components/Auth/LoginForm";
import Login from "../../Components/Auth/Login";
import LoginParCode from "../../Components/Auth/LoginParCode";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import MacAddressComponent from "../../Components/UserMacAdress/AddMacForm";
const CustomModalBody = styled(Modal.Body)`
  p {
    margin: 5px 0;
    color: #333;
  }
`;
const LoginPage: React.FC = () => {
  const [badge, setBadge] = useState(localStorage.getItem("Login"));
  const { t } = useTranslation();
  const [showMacAddressPopup ,setShowMacAddressPopup]=useState(false)
    const [showPinModal, setShowPinModal] = useState(false);
  

  useEffect(() => {
    if (badge === "Badge") {
      localStorage.setItem("Login", "Badge");
    } else {
      localStorage.setItem("Login", "mail");
    }
  }, [badge]);
  const handlePopupClose =()=>{
    setShowMacAddressPopup(false)
  }
  return (
    <div>
      {badge === "Badge" ? (
        <LoginParCode setBadge={setBadge} badge={badge} setShowMacAddressPopup={setShowMacAddressPopup} showPinModal={showPinModal} setShowPinModal={setShowPinModal} />
      ) : (
        <Login setBadge={setBadge} badge={badge}  setShowMacAddressPopup={setShowMacAddressPopup} showPinModal={showPinModal} setShowPinModal={setShowPinModal} />
      )}
      <Modal show={showMacAddressPopup}>
        <Modal.Header closeButton>
          <Modal.Title> {t("Appareil inconnue")}</Modal.Title>
        </Modal.Header>
        <CustomModalBody>
          <p>{t("Voulez-vous enregistrer cet appareil ?")}</p>
        </CustomModalBody>
        <Modal.Footer>
          <MacAddressComponent onClosePopup={handlePopupClose} setShowPinModal={setShowPinModal}  />
        </Modal.Footer>
      </Modal>
      *
    </div>
  );
};

export default LoginPage;
